import { render, staticRenderFns } from "./Formulario013aLab.vue?vue&type=template&id=73b0a39a"
import script from "./Formulario013aLab.vue?vue&type=script&lang=js"
export * from "./Formulario013aLab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports